import { useMemo } from "react";
import clsx from "clsx";

export enum SizeClassName {
  XSMALL = "h-px",
  SMALL = "h-1",
  NORMAL = "h-1.5",
  LARGE = "h-2",
  MLARGE = "h-3",
  XLARGE = "h-4",
}

interface ProgressBarProps {
  className?: string;
  size?: SizeClassName;
  percentage?: number;
  rounded?: boolean;
  infinite?: boolean;
}

export const ProgressBar = ({
  className,
  size = SizeClassName.SMALL,
  percentage,
  rounded,
  infinite = false,
}: ProgressBarProps) => {
  const progressBarWidth = useMemo(
    () => `${!!percentage && percentage > 0 && percentage <= 100 ? percentage : 0}%`,
    [percentage]
  );
  return (
    <div
      className={clsx("w-full", "relative", "overflow-hidden", "bg-background-surface-neutral-subtle", size, {
        "rounded-[5px]": rounded,
      })}
    >
      {infinite ? (
        <div
          className={clsx(
            "absolute",
            className ?? "bg-positive-500",
            size,
            "animate-infinite-loading",
            "absolute",
            "w-full",
            {
              "rounded-[5px]": rounded,
            }
          )}
          style={{
            height: "100%",
            top: "0%",
            transform: "translateY(-10%)",
          }}
          data-testid="infinite-line"
        />
      ) : (
        <div
          className={clsx(className ?? "bg-positive-500", size)}
          style={{ width: progressBarWidth }}
          data-testid="progress-bar"
        />
      )}
    </div>
  );
};
